/* eslint-disable @reatom/unit-naming-rule */
import { Result } from '@blade/std-lib'
import {
  fetchNewPairsRequestAction,
  pairRegistry,
} from '@root/entities/pair/atoms'

import { ExploreFilter } from '../../model'
import { ExploreFeedType } from '../../model/explore-feed-type'

import { reatomExploreTableBase } from './reatom-explore-table-base'

import type { PairModel } from '@root/entities/pair/atoms'
import type { TableData } from '@root/shared/ui-kit/data-table/atoms/reatom-data-table-state'

export const reatomExploreTableNew = () => {
  return reatomExploreTableBase({
    feedType: ExploreFeedType.New,
    loadPairs: async (
      ctx,
      {
        pagination: { limit, cursor },
        params: { filters, network, period },
        sorting,
      },
    ) => {
      const result = await ctx.schedule(() =>
        fetchNewPairsRequestAction(ctx, {
          filters: ExploreFilter.toPoolFiltersDto(filters, sorting, period),
          network,
          limit,
          cursor,
        }),
      )

      return Result.map(result, (value) => {
        const data: TableData<PairModel> = {
          data: value.data.map((it) => pairRegistry.resolveFromDto(ctx, it)),
          cursor: value.meta.nextCursor,
          hasNext: value.meta.hasNext,
        }

        return data
      })
    },
  })
}
